const PolandFlag = () => (
  <svg width="16" height="12" viewBox="0 0 30 20" style={{ marginRight: '4px', verticalAlign: 'middle' }}>
    <rect width="30" height="10" fill="#FFFFFF"/>
    <rect y="10" width="30" height="10" fill="#DC143C"/>
  </svg>
);

export default PolandFlag;